export default __webpack_public_path__ + "static/media/trustCheck.708a26c6.svg";